<template>
  <v-dialog v-model="dialog" max-width="500px" content-class="common-dialog">
    <v-card>
      <v-card-text>
        <h5 v-html="contentText"></h5>
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn depressed rounded v-if="useBtnCancel" @click="cancel">
          취소
        </v-btn> -->
        <v-btn  color="primary" depressed rounded block size="x-large" @click="ok">
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    useBtnCancel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
      contentText: "",
    };
  },
  methods: {
    open(_content) {
      this.contentText = _content;
      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
      this.$emit("clickCancel");
    },
    ok() {
      this.dialog = false;
      this.$emit("clickOk");
    },
  },
};
</script>

<style lang="scss">
.v-dialog.common-dialog {
  .v-card {
    .v-card__text {
      padding: 1.2rem 0 1rem;
      text-align: center;
    }

    .v-card__actions {
      padding: 1rem 0 0.5rem;
      justify-content: flex-end;

      .v-btn {
        height: 53px;
        font-size: 16px;
      }
    }
  }
}
</style>